// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"Ama-z","updatedSizingPrediction":"Bma-z","recommendedSize":"Cma-z","predictedSize":"Dma-z","recommendedSizeCopy":"Ema-z"};